import { Component, computed, inject, input, InputSignal } from '@angular/core';

import { TimezoneContextService } from '@lb/config/timezone.provider';

@Component({
	selector: 'lb-calendar-day-header',
	standalone: true,
	imports: [],
	templateUrl: './calendar-day-header.component.html',
	styleUrl: './calendar-day-header.component.scss'
})
export class CalendarDayHeaderComponent {
	public date: InputSignal<{ date: Date; format: string }> = input.required<{ date: Date; format: string }>();

	// Use day index to ensure consistent Sunday-Saturday columns
	// Timezone formatting can shift dates, breaking the day-index-based data structure
	public dayOfWeek = computed(() => {
		const dateObj = this.date().date;
		const dayIndex = dateObj.getDay(); // 0=Sunday, 1=Monday, ..., 6=Saturday
		const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
		return dayNames[dayIndex];
	});

	public dayOfMonth = computed(() => {
		const dateObj = this.date().date;
		return dateObj.getDate().toString();
	});
}
